import React from 'react'
import Drawer from "react-drag-drawer";
import { playSong } from '../../utils/song'
import songsName from '../../enums/songsName'
import { FiX } from 'react-icons/fi';
import LogoPng from '../../assets/images/new/logo.webp'
import { BsArrowLeftCircle } from 'react-icons/bs';

const AboutModal = (props) => {
  const closeHandler = () => {
    playSong(songsName.TAP)
    props.close()
  }

  return (
    <Drawer
      dontApplyListeners={true}
      allowClose={false}
      open={props.isOpened}
      onRequestClose={props.close}
      direction="left"
      containerElementClass="h-override"
      modalElementClass="h-override fixed top-0 left-0 z-10"
    >
      <div
        className={`w-screen max-w-lg h-override bg-modal flex flex-col justify-start items-start px-4 pb-4 text-lg overflow-y-auto`}
        style={{
          paddingTop: window.native_app_status_bar_height ?? 16,
          paddingBottom: window.native_app_navigation_bar_height ?? 16
        }}
      >
        <div className='w-full flex flex-row justify-between items-center'>
          <div className='w-full flex flex-row justify-between items-center'>
            <div
              className='flex flex-row justify-start items-center cursor-pointer'
              onMouseEnter={() => {
                playSong(songsName.TAP)
              }}
              onClick={() => {
                playSong(songsName.TAP)

                props.backToDrawerMenu()
              }}
            >
              <BsArrowLeftCircle className="w-8 h-8 text-pallet-1" />
            </div>

            <img src={LogoPng} className='h-8 mx-auto' alt='Logo' />

            <button
              type="button"
              onMouseEnter={() => {
                playSong(songsName.TAP)
              }}
              onClick={closeHandler}
              className={`text-black bg-transparent hover:bg-slate-200 rounded-lg text-2xl lg:text-xl`}
            >
              <FiX className="w-8 h-8 text-pallet-1" />
            </button>
          </div>
        </div>

        <h2 className='text-pallet-1 font-bold text-xl text-center mx-auto my-8'>Sobre nós</h2>
            <p className='text-lg mb-2'>
              Somos a Máquina de Contos, a plataforma dos contos brasileiros contemporâneos. Levamos aos nossos leitores, todos os meses, contos de grandes nomes da literatura atual, selecionados por primorosa curadoria, e contos de autores estreantes vencedores do Prêmio Literário Máquina de Contos.
            </p>

            <p className='text-lg mb-2'>
              Reencontre ou descubra os autores e autoras que estão fazendo a nossa literatura, em toda sua riqueza e diversidade.
            </p>

            <p className='text-lg'>
              A Máquina de Contos é operada pela Graviola Digital. Acreditamos no poder da literatura para transformar as pessoas e no poder das pessoas de transformar o mundo.
            </p>
      </div>
    </Drawer>
  )
}

export default AboutModal